import { create } from 'zustand';

interface HomeStore {
    
    filter: boolean;
    setFilter: (filter: boolean) => void;
    editList: boolean;
    setEditList: (editList: boolean) => void;

}

export const useHomeStore = create<HomeStore>((set) => ({

    filter: false,
    setFilter: (filterPassed) => set({ filter: filterPassed }),
    editList: false,
    setEditList: (editListPassed) => set({ editList: editListPassed })

}));